module.exports = __webpack_public_path__ + "img/banner-tc3-m.9b2c228d.jpg";